import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';

@Component({
  selector: 'app-active-vendor',
  templateUrl: './active-vendor.component.html',
  styleUrls: ['./active-vendor.component.css']
})
export class ActiveVendorComponent implements OnInit {

  constructor(
    public router: Router,
    public dialogRef: MatDialogRef<ActiveVendorComponent>,
  ) { }

  ngOnInit(): void {
  }

  onNoClick(): void {
    this.dialogRef.close();
    // this.router.navigate(['/vendors']);
  }

}
